import React, { Component } from 'react'
import { SearchInput, Pane, majorScale } from '@segment/react-ui-library'
import { debounce } from 'lodash'
import Table from './Table'
import css from './index.module.css'

class CustomersProfiles extends Component {
  constructor () {
    super()
    this.state = {
      id: '',
      type: 'email'
    }
    this.onKeyUp = this.onKeyUp.bind(this)
  }

  render () {
    return (
      <div className={css.main}>
        <Pane flex='1' display='flex' flexDirection='column' margin={majorScale(3)} overflow='hidden' border white>
          <Pane padding={majorScale(2)} borderBottom white position='relative'>
            <SearchInput
              onChange={(e) => this.setState({ id: e.target.value })}
              placeholder='Search by email..'
              className={css.searchInput}
              onKeyUp={this.onKeyUp} />
          </Pane>
          <Pane height='100%' width='100%'>
            <Table
              fetchCustomers={this.props.fetchCustomers}
              workspaceSlug={this.props.workspaceSlug}
              searchRequest={this.props.searchRequest}
              rowCount={this.props.rowCount}
              users={this.props.users}
              next={this.props.next}
              id={this.state.id} />
          </Pane>
        </Pane>
      </div>
    )
  }

  /**
   * Before the component unmounts, clear all local state and redux state. We
   * are doing this because we want the table to be completely reset when the
   * users returns.
   */

  componentWillUnmount () {
    this.setState({})
    this.props.setSearchingForCustomers(false)
  }

  /**
   * Before the component mounts, set up a debounced search function to avoid
   * needlessly hitting the API.
   */

  componentWillMount () {
    this.debouncedSearch = debounce(e => {
      if (!e.target.value) {
        this.props.setSearchingForCustomers(false)
      } else {
        this.props.setSearchingForCustomers(true)
        const { id, type } = this.state
        this.props.onFindUser({ id, type })
      }
    }, 500)
  }

  /**
   * Search for customers on every key up.
   */

  onKeyUp (e) {
    e.persist()
    this.debouncedSearch(e)
  }
}

export default CustomersProfiles



// WEBPACK FOOTER //
// ./components/Customers/CustomersProfiles/index.js